import FileDownload from "js-file-download";
import toastr from "toastr";

import { API } from "../_services/api";
import { ActionKeys } from "../_actions/constants/adminConstants";

import { downloadFileFromResponse } from "../_utils/downloadHelpers";

export const actionCreators = {
  getHelpTexts:
    (size = 10, offset = 0, sortBy = 1, sortDir = "asc") =>
    async (dispatch, getState) => {
      dispatch({ type: ActionKeys.REQUEST_HELP_TEXT });
      return dispatch(
        API.admin.getHelpText(size, offset, sortBy, sortDir)
      ).then(response => {
        dispatch({
          type: ActionKeys.RECEIVE_HELP_TEXT,
          isError: response.isError,
          helpTexts: response.items,
          total: response.count,
          errorMessage: response.errorMessage
        });
      });
    },
  updateHelpText: data => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_HELP_TEXT });
    return dispatch(API.admin.updateHelpText(data)).then(response => {
      dispatch({
        type: ActionKeys.UPDATE_HELP_TEXT,
        isError: response.isError,
        errorMessage: response.errorMessage,
        isSuccess: response.isSuccess
      });
    });
  },
  getFiscalYear: () => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_FISCAL_YEAR });
    return dispatch(API.admin.getFiscalYear()).then(response => {
      dispatch({
        type: ActionKeys.RECEIVE_FISCAL_YEAR,
        isError: response.isError,
        errorMessage: response.errorMessage,
        fiscalYear: response.item
      });
    });
  },
  updateFiscalYear: year => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_FISCAL_YEAR });
    return dispatch(API.admin.updateFiscalYear(year)).then(response => {
      dispatch({
        type: ActionKeys.UPDATE_FISCAL_YEAR,
        isError: response.isError,
        isSuccess: response.isSuccess,
        errorMessage: response.errorMessage,
        fiscalYear: year
      });
    });
  },
  getChapterRanges: () => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_CHAPTER_RANGES });
    return dispatch(API.admin.getChapterRanges()).then(response => {
      dispatch({
        type: ActionKeys.RECEIVE_CHAPTER_RANGES,
        isError: response.isError,
        chapterRanges: response.items,
        errorMessage: response.errorMessage
      });
    });
  },
  getMailingAddress: () => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_MAILING_ADDRESS });
    return dispatch(API.admin.getMailingAddress()).then(response => {
      dispatch({
        type: ActionKeys.RECEIVE_MAILING_ADDRESS,
        isError: response.isError,
        mailingAddress: response.item,
        errorMessage: response.errorMessage
      });
    });
  },
  updateMailingAddress: mailingAddress => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_MAILING_ADDRESS });
    return dispatch(API.admin.updateMailingAddress(mailingAddress)).then(
      response => {
        dispatch({
          type: ActionKeys.UPDATE_MAILING_ADDRESS,
          isError: response.isError,
          isSuccess: response.isSuccess,
          errorMessage: response.errorMessage,
          mailingAddress: mailingAddress.value
        });
      }
    );
  },

  updateChapterRanges: ranges => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_CHAPTER_RANGES });
    return dispatch(API.admin.updateChapterRanges(ranges)).then(response => {
      dispatch({
        type: ActionKeys.UPDATE_CHAPTER_RANGES,
        isError: response.isError,
        isSuccess: response.isSuccess,
        errorMessage: response.errorMessage
      });
    });
  },
  getMemberCounts:
    (
      size = 10,
      offset = 0,
      chapterId = -1,
      year = -1,
      sortBy = 1,
      sortDir = "asc"
    ) =>
    async (dispatch, getState) => {
      dispatch({ type: ActionKeys.REQUEST_MEMBER_COUNTS });
      return dispatch(
        API.admin.getMemberCounts(
          size,
          offset,
          chapterId,
          year,
          sortBy,
          sortDir
        )
      ).then(response => {
        dispatch({
          type: ActionKeys.RECEIVE_MEMBER_COUNTS,
          isError: response.isError,
          memberCounts: response.items,
          totalMemberCounts: response.count,
          errorMessage: response.errorMessage
        });
      });
    },
  createMemberCount: body => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_MEMBER_COUNTS });
    return dispatch(API.admin.createMemberCount(body)).then(response => {
      dispatch({
        type: ActionKeys.CREATE_MEMBER_COUNT,
        isSuccess: response.isSuccess,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
    });
  },
  updateMemberCount: body => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_MEMBER_COUNTS });
    return dispatch(API.admin.updateMemberCount(body)).then(response => {
      dispatch({
        type: ActionKeys.UPDATE_MEMBER_COUNT,
        isSuccess: response.isSuccess,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
    });
  },
  getChapterList: () => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_CHAPTER_LIST });
    return dispatch(API.admin.getChapterList()).then(response => {
      dispatch({
        type: ActionKeys.RECEIVE_CHAPTER_LIST,
        isError: response.isError,
        chapterList: response.items,
        totalChapters: response.count,
        errorMessage: response.errorMessage
      });
    });
  },
  getChapter: id => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_CHAPTER });
    return dispatch(API.admin.getChapter(id)).then(response => {
      dispatch({
        type: ActionKeys.RECEIVE_CHAPTER,
        activeChapter: response.item,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
    });
  },
  getChapterBudgets: year => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_CHAPTER_BUDGETS });
    return dispatch(API.admin.getChapterBudgets(year)).then(response => {
      dispatch({
        type: ActionKeys.RECEIVE_CHAPTER_BUDGETS,
        isError: response.isError,
        chapterBudgets: response.items,
        errorMessage: response.errorMessage
      });
    });
  },
  getChapterBudget: id => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_CHAPTER_BUDGET });
    return dispatch(API.admin.getChapterBudget(id)).then(response => {
      dispatch({
        type: ActionKeys.RECEIVE_CHAPTER_BUDGET,
        isError: response.isError,
        activeChapterBudget: response.item,
        errorMessage: response.errorMessage
      });
    });
  },
  createChapterBudget: body => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.CREATE_CHAPTER_BUDGET_STARTED });
    return dispatch(API.admin.createChapterBudget(body)).then(response => {
      dispatch({
        type: ActionKeys.CREATE_CHAPTER_BUDGET_FINISHED,
        isSuccess: response.isSuccess,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
      return response;
    });
  },
  updateChapterBudget: body => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.UPDATE_CHAPTER_BUDGET_STARTED });
    return dispatch(API.admin.updateChapterBudget(body)).then(response => {
      dispatch({
        type: ActionKeys.UPDATE_CHAPTER_BUDGET_FINISHED,
        isSuccess: response.isSuccess,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
      return response.isError ? response.errorMessage : true;
    });
  },
  updateChapterBudgetFile: (id, body) => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.UPDATE_CHAPTER_BUDGET_FILE_STARTED });
    return dispatch(API.admin.updateChapterBudgetFile(id, body)).then(
      response => {
        dispatch({
          type: ActionKeys.UPDATE_CHAPTER_BUDGET_FILE_FINISHED,
          isSuccess: response.isSuccess,
          isError: response.isError,
          errorMessage: response.errorMessage
        });
        return response.isError ? response.errorMessage : true;
      }
    );
  },
  downloadChapterBudgetFile: (id, filename) => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.DOWNLOAD_CHAPTER_BUDGET_FILE_STARTED });
    return dispatch(API.admin.downloadChapterBudgetFile(id, filename)).then(
      response => {
        if (response.status === 200) {
          toastr.success("Download started...");
          FileDownload(response.data, filename);
        }
        dispatch({
          type: ActionKeys.DOWNLOAD_CHAPTER_BUDGET_FILE_FINISHED,
          isSuccess: response.isSuccess,
          isError: response.status !== 200,
          errorMessage: response.status === 200 ? "" : "Not Found"
        });

        return response.isError ? response.errorMessage : true;
      }
    );
  },
  getChapterAnalysisReports:
    (year, chapterid) => async (dispatch, getState) => {
      dispatch({ type: ActionKeys.REQUEST_CHAPTER_ANALYSIS_REPORTS });
      return dispatch(
        API.admin.getChapterAnalysisReports(year, chapterid)
      ).then(response => {
        dispatch({
          type: ActionKeys.RECEIVE_CHAPTER_ANALYSIS_REPORTS,
          reports: response.items,
          totalReports: response.count,
          isError: response.isError,
          errorMessage: response.errorMessage
        });
      });
    },
  getChapterFinancials: year => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_CHAPTER_FINANCIALS });
    return dispatch(API.admin.getChapterFinancials(year)).then(response => {
      dispatch({
        type: ActionKeys.RECEIVE_CHAPTER_FINANCIALS,
        chapterFinancials: response.items,
        totalChapterFinancials: response.count,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
    });
  },
  getChapterFinancial: id => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_CHAPTER_FINANCIAL });
    return dispatch(API.admin.getChapterFinancial(id)).then(response => {
      dispatch({
        type: ActionKeys.RECEIVE_CHAPTER_FINANCIAL,
        activeChapterFinancial: response.item,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
    });
  },
  getChapterFinancialByYear: (year, id) => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_CHAPTER_FINANCIAL_BY_YEAR });
    return dispatch(API.admin.getChapterFinancialByYear(year, id)).then(
      response => {
        dispatch({
          type: ActionKeys.RECEIVE_CHAPTER_FINANCIAL_BY_YEAR,
          isSuccess: response.isSuccess,
          isError: response.isError,
          errorMessage: response.errorMessage
        });
        return response.items;
      }
    );
  },
  getChapterFinancialById: id => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.RECEIVE_CHAPTER_FINANCIAL });
    return dispatch(API.admin.getChapterFinancial(id)).then(response => {
      dispatch({
        type: ActionKeys.RECEIVE_CHAPTER_FINANCIAL,
        isSuccess: response.isSuccess,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
      return response.item;
    });
  },
  getChapterFinancialsDefaults: () => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_CHAPTER_FINANCIALS_DEFAULTS });
    return dispatch(API.admin.getChapterFinancialsDefaults()).then(response => {
      dispatch({
        type: ActionKeys.RECEIVE_CHAPTER_FINANCIALS_DEFAULTS,
        chapterFinancialsDefaults: response.items,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
    });
  },
  getChapterSummaryReport: id => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_CHAPTER_SUMMARY_REPORT });
    return dispatch(API.admin.getChapterSummaryReport(id)).then(response => {
      downloadFileFromResponse(response, "chapter_summary.pdf");
      dispatch({
        type: ActionKeys.RECEIVE_CHAPTER_SUMMARY_REPORT,
        isError: false
      });
    });
  },
  getGlobalAnalysisReport: (type, year) => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_CHAPTER_SUMMARY_REPORT });
    return dispatch(API.admin.getGlobalAnalysisReport(type, year)).then(
      response => {
        var filename = "global_analysis_report.xlsx";
        if (type === "cash") {
          filename = "cash_reserve_report.xlsx";
        } else if (type === "employment") {
          filename = "chapter_employment_statistics.xlsx";
        } else if (type === "fiscal") {
          filename = "chapter_fiscal_year_net_statistics.xlsx";
        } else if (type === "employmentDetails") {
          filename = "chapter_employment_details_report.xlsx";
        }
        downloadFileFromResponse(response, filename);
        dispatch({
          type: ActionKeys.RECEIVE_CHAPTER_SUMMARY_REPORT,
          isError: false
        });
      }
    );
  },
  get990Report: (type, year) => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_CHAPTER_SUMMARY_REPORT });
    return dispatch(API.admin.get990Report(type, year)).then(response => {
      var filename = "chapter_report.xlsx";
      if (type === "all") {
        filename = "all_chapter_report.xlsx";
      } else if (type === "admin") {
        filename = "chapter_admin_report.xlsx";
      } else if (type === "contributions") {
        filename = "chapter_contribution_report.xlsx";
      } else if (type === "scholarship") {
        filename = "chapter_scholarship_report.xlsx";
      } else if (type === "advertising") {
        filename = "chapter_advertising_report.xlsx";
      } else if (type === "vendor") {
        filename = "chapter_vendor_report.xlsx";
      } else if (type === "otherExpense") {
        filename = "chapter_other_expense_report.xlsx";
      } else if (type === "otherRevenue") {
        filename = "chapter_other_revenue_report.xlsx";
      }

      downloadFileFromResponse(response, filename);
      dispatch({
        type: ActionKeys.RECEIVE_CHAPTER_SUMMARY_REPORT,
        isError: false
      });
    });
  },
  getFinancialReport: (status, year) => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_CHAPTER_FINANCIAL_REPORT });
    return dispatch(API.admin.getFinancialReport(status, year)).then(
      response => {
        var filename = "financial_report.xlsx";

        downloadFileFromResponse(response, filename);
        dispatch({
          type: ActionKeys.RECEIVE_CHAPTER_FINANCIAL_REPORT,
          isError: false
        });
      }
    );
  },
  getMemberCountTemplate: () => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_CHAPTER_MEMBER_COUNT_TEMPLATE });
    return dispatch(API.admin.getMemberCountTemplate()).then(response => {
      var filename = "member_count_template.csv";

      downloadFileFromResponse(response, filename);
      dispatch({
        type: ActionKeys.RECEIVE_CHAPTER_MEMBER_COUNT_TEMPLATE,
        isError: false
      });
    });
  },
  uploadMemberCounts: data => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.UPLOAD_MEMBER_COUNTS });
    return dispatch(API.admin.uploadMemberCounts(data)).then(response => {
      dispatch({
        type: ActionKeys.UPLOADED_MEMBER_COUNTS,
        isError: response.isError,
        isSuccess: response.isSuccess,
        errorMessage: response.errorMessage,
        message: response.message
      });
    });
  },
  getYearToYearReport: id => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_CHAPTER_SUMMARY_REPORT });
    return dispatch(API.admin.getYearToYearReport(id)).then(response => {
      downloadFileFromResponse(response, "year_to_year.xlsx");
      dispatch({
        type: ActionKeys.RECEIVE_CHAPTER_SUMMARY_REPORT,
        isError: false
      });
    });
  },
  getComparativeReport: id => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_CHAPTER_SUMMARY_REPORT });
    return dispatch(API.admin.getComparativeReport(id)).then(response => {
      downloadFileFromResponse(response, "comparative.xlsx");
      dispatch({
        type: ActionKeys.RECEIVE_CHAPTER_SUMMARY_REPORT,
        isError: false
      });
    });
  },
  submitChapterFinancial: (id, notes) => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.SUBMIT_CHAPTER_FINANCIAL_STARTED });
    return dispatch(API.admin.submitChapterFinancial(id, notes)).then(
      response => {
        dispatch({
          type: ActionKeys.SUBMIT_CHAPTER_FINANCIAL_FINISHED,
          isSuccess: response.isSuccess,
          isError: response.isError,
          errorMessage: response.errorMessage
        });
      }
    );
  },
  getReportItemTypes: () => (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_REPORT_ITEM_TYPES });
    return dispatch(API.admin.getReportItemTypes()).then(response => {
      dispatch({
        type: ActionKeys.RECEIVE_REPORT_ITEM_TYPES,
        reportItemTypes: response.items,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
    });
  },
  getReportItemSubTypes: () => (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_REPORT_ITEM_SUB_TYPES });
    return dispatch(API.admin.getReportItemTypes()).then(response => {
      dispatch({
        type: ActionKeys.RECEIVE_REPORT_ITEM_SUB_TYPES,
        reportItemSubTypes: response.items,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
    });
  },
  updateReportItemNotes: (id, body) => (dispatch, getState) => {
    dispatch({ type: ActionKeys.UPDATE_REPORT_ADMIN_NOTES_STARTED });
    return dispatch(API.admin.updateReportItemNotes(id, body)).then(
      response => {
        dispatch({
          type: ActionKeys.UPDATE_REPORT_ADMIN_NOTES_FINISHED,
          isSuccess: response.isSuccess,
          isError: response.isError,
          errorMessage: response.errorMessage
        });
      }
    );
  },
  createReportItemNotes: (id, year, body) => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.CREATE_REPORT_ADMIN_NOTES_STARTED });
    return dispatch(API.admin.createReportItemNotes(id, year, body)).then(
      response => {
        dispatch({
          type: ActionKeys.CREATE_REPORT_ADMIN_NOTES_FINISHED,
          isSuccess: response.isSuccess,
          activeChapterFinancial: response.item,
          isError: response.isError,
          errorMessage: response.errorMessage
        });
        return response.item;
      }
    );
  },
  createReportItem: body => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.CREATE_REPORT_ITEM_STARTED });
    return dispatch(API.admin.createReportItem(body)).then(response => {
      dispatch({
        type: ActionKeys.CREATE_REPORT_ITEM_FINISHED,
        isSuccess: response.isSuccess,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
      return response.item;
    });
  },
  updateReportItem: (id, body) => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.UPDATE_REPORT_ITEM_STARTED });
    return dispatch(API.admin.updateReportItem(id, body)).then(response => {
      dispatch({
        type: ActionKeys.UPDATE_REPORT_ITEM_FINISHED,
        isSuccess: response.isSuccess,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
    });
  },
  removeReportItem: id => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REMOVE_REPORT_ITEM_STARTED });
    return dispatch(API.admin.removeReportItem(id)).then(response => {
      dispatch({
        type: ActionKeys.REMOVE_REPORT_ITEM_FINISHED,
        isSuccess: response.isSuccess,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
    });
  },
  updateReportItems: body => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.UPDATE_REPORT_ITEMS_STARTED });
    return dispatch(API.admin.updateReportItems(body)).then(response => {
      dispatch({
        type: ActionKeys.UPDATE_REPORT_ITEMS_FINISHED,
        isSuccess: response.isSuccess,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
    });
  },
  updateReportItemsPut: body => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.UPDATE_REPORT_ITEMS_STARTED });
    return dispatch(API.admin.updateReportItemsPut(body)).then(response => {
      dispatch({
        type: ActionKeys.UPDATE_REPORT_ITEMS_FINISHED,
        isSuccess: response.isSuccess,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
    });
  },
  initialReportItems: body => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.INITIAL_REPORT_ITEMS_STARTED });
    return dispatch(API.admin.initialReportItems(body)).then(response => {
      dispatch({
        type: ActionKeys.INITIAL_REPORT_ITEMS_FINISHED,
        isSuccess: response.isSuccess,
        isError: response.isError,
        errorMessage: response.errorMessage
      });

      return response.message;
    });
  },
  updateReportW2: body => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.UPDATE_REPORT_W2_STARTED });
    return dispatch(API.admin.updateReportW2(body)).then(response => {
      dispatch({
        type: ActionKeys.UPDATE_REPORT_W2_FINISHED,
        isSuccess: response.isSuccess,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
    });
  },
  updateVotingCount: body => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.UPDATE_REPORT_VOTING_COUNT_STARTED });
    return dispatch(API.admin.updateVotingCount(body)).then(response => {
      dispatch({
        type: ActionKeys.UPDATE_REPORT_VOTING_COUNT_FINISHED,
        isSuccess: response.isSuccess,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
    });
  },
  createFinancialAccount: body => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.CREATE_FINANCIAL_ACCOUNT_STARTED });
    return dispatch(API.admin.createFinancialAccount(body)).then(response => {
      dispatch({
        type: ActionKeys.CREATE_FINANCIAL_ACCOUNT_FINISHED,
        isSuccess: response.isSuccess,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
    });
  },
  updateFinancialAccount: body => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.UPDATE_FINANCIAL_ACCOUNT_STARTED });
    return dispatch(API.admin.updateFinancialAccount(body)).then(response => {
      dispatch({
        type: ActionKeys.UPDATE_FINANCIAL_ACCOUNT_FINISHED,
        isSuccess: response.isSuccess,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
    });
  },
  removeFinancialAccount: body => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REMOVE_FINANCIAL_ACCOUNT_STARTED });
    return dispatch(API.admin.removeFinancialAccount(body)).then(response => {
      dispatch({
        type: ActionKeys.REMOVE_FINANCIAL_ACCOUNT_FINISHED,
        isSuccess: response.isSuccess,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
    });
  },
  acceptChapterFinancial: (id, body) => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.ACCEPT_CHAPTER_FINANCIAL_STARTED });
    return dispatch(API.admin.acceptChapterFinancial(id, body)).then(
      response => {
        dispatch({
          type: ActionKeys.ACCEPT_CHAPTER_FINANCIAL_FINISHED,
          isSuccess: response.isSuccess,
          isError: response.isError,
          errorMessage: response.errorMessage
        });
      }
    );
  },
  rejectChapterFinancial: (id, body) => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REJECT_CHAPTER_FINANCIAL_STARTED });
    return dispatch(API.admin.rejectChapterFinancial(id, body)).then(
      response => {
        dispatch({
          type: ActionKeys.REJECT_CHAPTER_FINANCIAL_FINISHED,
          isSuccess: response.isSuccess,
          isError: response.isError,
          errorMessage: response.errorMessage
        });
      }
    );
  },
  resetIsFetched: () => (dispatch, getState) => {
    dispatch({ type: ActionKeys.RESET_IS_FETCHED });
  },
  resetActiveChapterBudget: () => (dispatch, getState) => {
    dispatch({ type: ActionKeys.RESET_ACTIVE_CHAPTER_BUDGET });
  }
};
